.popover {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--z-dropdown);
  min-width: 12rem;
  max-width: calc(100vw - 16px);
  overflow: auto;
  background-color: var(--color-surface-raised);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  color: var(--color-text);
  animation: pop-in var(--duration-fast) var(--ease-out);
}

.popover:focus-visible {
  outline: none;
}

@keyframes pop-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
}

@media (forced-colors: active) {
  .popover {
    border-color: CanvasText;
  }
}
